import { render, staticRenderFns } from "./messageThread.vue?vue&type=template&id=5fddd264&scoped=true"
import script from "./messageThread.vue?vue&type=script&lang=js"
export * from "./messageThread.vue?vue&type=script&lang=js"
import style0 from "./messageThread.vue?vue&type=style&index=0&id=5fddd264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fddd264",
  null
  
)

export default component.exports